import React, { Suspense } from 'react';

import { Outlet } from 'react-router-dom';

import { GlobalBackground } from '@/components/Common/GlobalBackground';

import { LocalStorageProvider } from '@/contexts/localStorage.context';
import { SidebarContextProvider } from '@/contexts/sidebar.context';

import { PageLoader } from '@/elements/PageLoader';

import { AuthProvider } from '@/providers/Auth.provider';
import { ErrorBoundary } from '@/providers/ErrorBoundary';

const AppLayout: React.FC = () => {
  return (
    <LocalStorageProvider>
      <ErrorBoundary>
        <SidebarContextProvider>
          <GlobalBackground>
            <AuthProvider>
              <Suspense fallback={<PageLoader />}>
                <Outlet />
              </Suspense>
            </AuthProvider>
          </GlobalBackground>
        </SidebarContextProvider>
      </ErrorBoundary>
    </LocalStorageProvider>
  );
};

export default AppLayout;
